import { post } from './httpClient'
import type {
  CreateBetaRegistrationRequest,
  CreateBetaRegistrationResponse,
} from '../models/BetaRegistration'
import { apiRoutes } from '../config/api'

export function createBetaRegistration(request: CreateBetaRegistrationRequest) {
  return post<CreateBetaRegistrationRequest, CreateBetaRegistrationResponse>(
    apiRoutes.betaRegistrations,
    request,
  )
}
